var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMintIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 16,
    viewBox: "0 0 18 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 3L7.5 2L6.5 1.5L7.5 1L8 0L8.5 1L9.5 1.5L8.5 2L8 3ZM3.5 5L2.65625 3.34375L1 2.5L2.65625 1.6875L3.5 0L4.3125 1.6875L6 2.5L4.3125 3.34375L3.5 5ZM3.5 2C3.21875 2 3 2.25 3 2.5C3 2.78125 3.21875 3 3.5 3C3.75 3 4 2.78125 4 2.5C4 2.25 3.75 2 3.5 2ZM14.5 9L15.3125 10.6875L17 11.5L15.3125 12.3438L14.5 14L13.6562 12.3438L12 11.5L13.6562 10.6875L14.5 9ZM14.5 12C14.75 12 15 11.7812 15 11.5C15 11.25 14.75 11 14.5 11C14.2188 11 14 11.25 14 11.5C14 11.7812 14.2188 12 14.5 12ZM16.6875 2.4375C17.0938 2.84375 17.0938 3.46875 16.6875 3.875L4.84375 15.7188C4.625 15.9062 4.375 16 4.125 16C3.875 16 3.625 15.9062 3.40625 15.7188L1.28125 13.5938C0.875 13.1875 0.875 12.5625 1.28125 12.1562L13.125 0.3125C13.3438 0.125 13.5938 0 13.8438 0C14.0938 0 14.3438 0.125 14.5625 0.3125L16.6875 2.4375ZM4.125 15L12.1875 6.9375L10.0625 4.8125L2 12.875L4.125 15ZM12.9062 6.21875L16 3.15625L13.8438 1L10.7812 4.09375L12.9062 6.21875Z",
    fill: "url(#paint0_linear_1720_1996)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1720_1996",
    x1: 2.09474,
    y1: 3.57895,
    x2: 9.59191,
    y2: 16.3839,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFAB00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD76F"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMintIcon);
export default __webpack_public_path__ + "static/media/mintIcon.ce9c90e71d600709be1f8a73db9aee1f.svg";
export { ForwardRef as ReactComponent };